import React from 'react';
import { GenericQrCodeInfo } from 'components';

const GenericQRCodeComponent = (props) => {
    return <GenericQrCodeInfo {...props} />;
};

export default GenericQRCodeComponent;
